<template>
  <div>
    <img
      :src="api_url + teams[0].logo.url"
    >

    <div class="uk-section">
      <div class="uk-container uk-container-small">
      <h1>{{ teams[0].name }}</h1>
        {{ teams[0].url }}
        <vue-markdown-it
          v-if="teams[0].bio"
          :source="teams[0].bio"
          id="editor"
        />
      </div>
    </div>
  </div>
</template>

<style lang="css">

</style>

<script>
var moment = require("moment");
import VueMarkdownIt from "vue-markdown-it";
import gql from "graphql-tag";

export default {
  data() {
    return {
      teams: {},
      moment: moment,
      api_url: process.env.VUE_APP_STRAPI_API_URL,
      routeParam: this.$route.params.id
    };
  },
  name: "Team",
  components: {
    VueMarkdownIt
  },
  apollo: {
    teams: {
      query: gql`
        query Teams($slug: String!) {
            teams(where: { slug: $slug }) {
              slug,
              name,
              logo {
                url
              },
              url
        }
        }
      `,
      variables() {
          console.log('Test:' + this.routeParam)
        return {
          slug: this.routeParam
        };
      }
    }
  }
};
</script>